<template>
  <div class="ally-switcher">
    <div class="ally-switcher__slide" ref="slide" :style="slideStyles"/>
    <slot :toggleBodyClass="toggleBodyClass"/>
  </div>
</template>

<script>
  export default {
    name: 'ally-switcher',
    props: {
      classToAdd: {
        type: String,
        required: false,
        default: undefined
      },
      isVisible: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        isSwitcherEnabled: false,
        slideStyles: {
          width: '50%',
          right: '3px'
        }
      };
    },

    computed: {
      switcherName() {
        return this.classToAdd.replace('-', '');
      }
    },

    watch: {
      isVisible(value) {
        value && this.moveSwitcher();
      }
    },

    mounted() {
      const userPreference = localStorage.getItem(this.switcherName);
      this.isSwitcherEnabled = userPreference ? JSON.parse(userPreference) : false;

      this.setToLocalStorage();
      this.$nextTick(() => {
        this.setRadioOnMount();
        this.toggleBodyClass(this.isSwitcherEnabled);
      });

    },

    methods: {
      toggleBodyClass(value) {
        this.isSwitcherEnabled = value;
        if (value) {
          document.body.classList.add(this.classToAdd);
        } else {
          document.body.classList.remove(this.classToAdd);
        }

        this.moveSwitcher();
        this.setToLocalStorage();
      },
      moveSwitcher() {
        const inputId = this.$el.querySelector('input:checked').getAttribute('id');
        const activeBtnCoords = this.$el.querySelector(`label[for="${inputId}"]`).getBoundingClientRect();
        const parentCoords = this.$el.getBoundingClientRect();
        this.slideStyles = {
          width: `${activeBtnCoords.width}px`,
          left: `${activeBtnCoords.left - parentCoords.left}px`
        };
      },
      setToLocalStorage() {
        localStorage.setItem(this.switcherName, this.isSwitcherEnabled);
      },
      setRadioOnMount() {
        const buttons = this.$el.querySelectorAll('input');
        this.isSwitcherEnabled ? buttons[1].checked = true : buttons[0].checked = true;
      }
    }
  };
</script>

<style lang="scss" src="./ally-switcher.scss"></style>
